import React from 'react';
import moment from 'moment';
import { Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Pagination } from '../../Pagination';
import { useGetActionPlanReview } from '../_hooks';

import * as S from './styles';

const DEFAULT_TOTAL = 0;

export function TableActionPlanReview(): JSX.Element {
	const { previousMCP, previousActionPlanData, currentPage, limit, setCurrentPage } = useGetActionPlanReview();

	function handleOnChangePage(page: number): void {
		setCurrentPage(page);
	}

	return (
		<S.TableWrapper>
			<S.CustomTable>
				<thead>
					<tr>
						<th style={{ width: '10%', textAlign: 'center' }}>No.</th>
						<th colSpan={2} style={{ width: '60%', textAlign: 'center' }}>
							{I18n.get('General Preventive Measures')}
						</th>
						<th style={{ width: '30%', textAlign: 'center' }}>{I18n.get('Observations')}</th>
					</tr>
				</thead>
				<tbody>
					{previousMCP &&
						previousMCP.length &&
						previousMCP.map((item) => (
							<tr key={item.number}>
								<td style={{ width: '5%', textAlign: 'center' }}>{item.number}</td>
								<td style={{ width: '40%' }}>{item.measure}</td>
								<td style={{ width: '5%', textAlign: 'center' }}>{item.response}</td>
								<td style={{ width: '50%', textAlign: 'center' }}>{item.observation || '-'}</td>
							</tr>
						))}
				</tbody>
			</S.CustomTable>
			<S.CustomTable>
				<thead>
					<tr>
						<th style={{ width: '8%', textAlign: 'center' }}>No. M.C.P</th>
						<th style={{ width: '15%', textAlign: 'center' }}>{I18n.get('Action plan name')}</th>
						<th style={{ width: '20%', textAlign: 'center' }}>
							{I18n.get('Specific administrative corrective and preventive measure')}
						</th>
						<th style={{ width: '12%', textAlign: 'center' }}>{I18n.get('Due date')}</th>
						<th style={{ width: '20%', textAlign: 'center' }}>
							{I18n.get('Specific engineering corrective and preventive measure')}
						</th>
						<th style={{ width: '12%', textAlign: 'center' }}>{I18n.get('Due date')}</th>
					</tr>
				</thead>
				<tbody>
					{previousActionPlanData && previousActionPlanData.length ? (
						previousActionPlanData.map((item) => (
							<tr key={item.number}>
								<td style={{ textAlign: 'center' }}>{item.number}</td>
								<td>{item.actionPlanName}</td>
								<td style={{ textAlign: 'center' }}>{item.administrativeMeasure}</td>
								<td style={{ textAlign: 'center' }}>
									{item.administrativeDueDate
										? moment(item.administrativeDueDate).format('DD/MM/YYYY')
										: '-'}
								</td>
								<td style={{ textAlign: 'center' }}>{item.engineeringMeasure}</td>
								<td style={{ textAlign: 'center' }}>
									{item.engineeringDueDate
										? moment(item.engineeringDueDate).format('DD/MM/YYYY')
										: '-'}
								</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan={6} style={{ textAlign: 'center' }}>
								{I18n.get('No data')}
							</td>
						</tr>
					)}
				</tbody>
			</S.CustomTable>
			{previousActionPlanData && previousActionPlanData.length > 0 && (
				<Col span={24} style={{ marginBottom: '32px' }}>
					<Pagination
						total={previousActionPlanData?.length || DEFAULT_TOTAL}
						limit={limit}
						currentPage={currentPage}
						onChangePage={handleOnChangePage}
						style={{ justifyContent: 'space-between', width: '100%' }}
					/>
				</Col>
			)}
		</S.TableWrapper>
	);
}
